import React from 'react';
import LoginModal from '../LoginModal';
import SaveDialog from '../SaveDialog';
import LoadDialog from '../LoadDialog';
import LoadConfirmDialog from '../LoadConfirmDialog';
import DatabaseSaveDialog from '../DatabaseSaveDialog';
import SchuelerModal from './SchuelerModal';
import MergeDuplicatesModal from './MergeDuplicatesModal';
import BatchOperationsModal from './BatchOperationsModal';

const Modals = ({
  loginData,
  saveLoadData,
  schuelerData,
  newPlanData,
  mergeData,
  batchOperationsData
}) => {
  const {
    showLogin,
    loginForm,
    loginError,
    handleLoginClose,
    handleLoginSubmit,
    handleInputChange
  } = loginData;

  const {
    showSaveDialog,
    setShowSaveDialog,
    showLoadDialog,
    setShowLoadDialog,
    showLoadConfirmDialog,
    loadMode,
    setLoadMode,
    jsonData,
    loadJsonData,
    setLoadJsonData,
    saveFileName,
    setSaveFileName,
    handleFileUpload,
    handleLoadSubmit,
    handleLoadConfirm,
    handleLoadConfirmCancel,
    handleDownloadFile,
    // Database save/load
    showDatabaseSaveDialog,
    setShowDatabaseSaveDialog,
    // eslint-disable-next-line no-unused-vars
    planName,
    // eslint-disable-next-line no-unused-vars
    planDescription,
    // eslint-disable-next-line no-unused-vars
    isUpdatingExistingPlan,
    // eslint-disable-next-line no-unused-vars
    handleDatabaseSaveSubmit
  } = saveLoadData;

  const {
    showSchuelerModal,
    setShowSchuelerModal
  } = schuelerData;

  // Wrapper fuer Datenbank-Speichern mit Zeitverschiebung
  const handleDatabaseSaveWithTimeShift = (planName, planDescription, selectedExistingPlan, timeShiftData) => {
    return saveLoadData.handleDatabaseSaveSubmit(planName, planDescription, selectedExistingPlan, false, false, null, timeShiftData);
  };

  // NewPlanDialog nicht mehr benoetigt - direkte Implementierung

  const {
    showMergeModal,
    setShowMergeModal,
    handleMergeConfirm
  } = mergeData || {};

  const {
    showBatchModal,
    setShowBatchModal,
    selectedTasks,
    handleBatchConfirm,
    allTasks,
    allPanels
  } = batchOperationsData || {};

  return (
    <>
      <LoginModal
        open={showLogin}
        onClose={handleLoginClose}
        onSubmit={handleLoginSubmit}
        form={loginForm}
        onChange={handleInputChange}
        error={loginError}
      />

      <SaveDialog
        show={showSaveDialog}
        onClose={() => setShowSaveDialog(false)}
        jsonData={jsonData}
        saveFileName={saveFileName}
        setSaveFileName={setSaveFileName}
        onDownloadFile={handleDownloadFile}
        onDatabaseSave={saveLoadData.handleDatabaseSaveSubmit}
        currentPlanName={saveLoadData.currentPlanName}
      />

      <LoadDialog
        show={showLoadDialog}
        onClose={() => setShowLoadDialog(false)}
        loadJsonData={loadJsonData}
        setLoadJsonData={setLoadJsonData}
        onFileUpload={handleFileUpload}
        onLoadSubmit={handleLoadSubmit}
        onDatabaseLoad={saveLoadData.handleLoadFromDatabase}
        user={loginData.user}
      />

      <LoadConfirmDialog
        show={showLoadConfirmDialog}
        loadMode={loadMode}
        setLoadMode={setLoadMode}
        onConfirm={handleLoadConfirm}
        onCancel={handleLoadConfirmCancel}
      />

      <DatabaseSaveDialog
        show={showDatabaseSaveDialog}
        onClose={() => setShowDatabaseSaveDialog(false)}
        onSave={handleDatabaseSaveWithTimeShift}
        initialName={saveLoadData.planName}
        initialDescription={saveLoadData.planDescription}
        isUpdate={saveLoadData.isUpdatingExistingPlan}
        userId={loginData.user?.username || 'test_user'}
        currentPlanName={saveLoadData.currentPlanName}
      />

      <SchuelerModal
        show={showSchuelerModal}
        onClose={() => setShowSchuelerModal(false)}
        existingStudents={[]}
        currentTaskData={null}
      />

      {/* NewPlanDialog entfernt - direkte Implementierung in handleCreateNewPlan */}

      {mergeData && (
        <MergeDuplicatesModal
          show={showMergeModal}
          onClose={() => setShowMergeModal(false)}
          onConfirm={handleMergeConfirm}
        />
      )}

      {batchOperationsData && (
        <BatchOperationsModal
          show={showBatchModal}
          onClose={() => setShowBatchModal(false)}
          selectedTasks={selectedTasks}
          onConfirm={handleBatchConfirm}
          allTasks={allTasks}
          allPanels={allPanels}
        />
      )}
    </>
  );
};

export default Modals;
